import { NavigationItem } from "../../../../constants";
import {
  COACH_BRANDED_APP_ROUTE,
  COACH_CLIENT_PORTAL_ROUTE,
  COACH_FEATURES_SETTINGS_ROUTE as COACH_FEATURE_SETTINGS_ROUTE,
  COACH_PLAN_ROUTE,
  COACH_PROFILE_ROUTE,
  COACH_SETTING_NOTIFICATIONS_ROUTE,
  COACH_THEME_ROUTE,
} from "../../../routes";

export const coachClientPortalNavigation: NavigationItem[] = [
  {
    name: "Settings",
    link: COACH_CLIENT_PORTAL_ROUTE,
  },

  {
    name: "Features",
    link: COACH_FEATURE_SETTINGS_ROUTE,
  },

  {
    name: "Theme",
    link: COACH_THEME_ROUTE,
  },
  {
    name: "Branded app",
    link: COACH_BRANDED_APP_ROUTE,
  },
];

export const coachSettingsNavigation = (
  subscribed?: boolean,
): NavigationItem[] => [
  {
    name: "Profile",
    link: COACH_PROFILE_ROUTE,
  },
  {
    name: "Notifications",
    link: COACH_SETTING_NOTIFICATIONS_ROUTE,
  },
  {
    name: subscribed ? "Plan" : "Upgrade",
    link: COACH_PLAN_ROUTE,
  },
];
